import React from 'react';
import { sanitize } from '../../lib/sanitize';
import styles from './ProductDescription.module.css';

interface ProductDescriptionProps {
  description: string;
}

const ProductDescription: React.FC<ProductDescriptionProps> = ({ description }) => {
  return (
    <div
      className={styles.description}
      dangerouslySetInnerHTML={{ __html: sanitize(description) }}
    />
  );
};

export default ProductDescription;
